import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhatYouGet } from './components/WhatYouGet';
import { Benefits } from './components/Benefits';
import { FaqSection } from './components/FaqSection';
import { InstantAccess } from './components/InstantAccess';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  /** Show the limited-offer countdown block under the What You Get CTA. */
  showUrgencyBanner?: boolean;
  /** Full-bleed stadium hero, or a split hero led by the product bundle. */
  heroVariant?: 'stadium' | 'bundle';
}
export function App({
  showUrgencyBanner = true,
  heroVariant = 'stadium'
}: AppProps) {
  return <div className="w-full bg-navy-950 font-sans" data-id="element-0" data-mp="28te2td7e19n3">
      <main data-id="element-1" data-mp="28s2z1ddy01vz">
        <Hero variant={heroVariant} data-id="element-2" data-mp="23vkvuhy9gblr" />
        <SocialProof data-id="element-3" data-mp="23ujkecdc1n3i" />
        <WhatYouGet data-id="element-4" data-mp="23v2sl1d6kx4c" />
        <FinalCta data-id="element-5" data-mp="23ti5txx3yih1" />
        <Benefits data-id="element-6" data-mp="3ik7jmqgv0tve" />
        <FaqSection data-id="element-7" data-mp="3iiwdijzxza14" />
        <InstantAccess showUrgency={showUrgencyBanner} data-id="element-8" data-mp="3ijfw82xf22g7" />
        <Guarantee data-id="element-9" data-mp="3ml14faz09sk2" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3mk85gw6ag7ch" />
    </div>;
}